import * as React from 'react';
import { Tooltip } from 'react-tippy';

export class CustomTooltip extends React.PureComponent<any> {
  render() {
    return (
      <Tooltip
        position="right"
        trigger="mouseenter"
        html={
          (
            <div style={{ fontSize: '12px', width: '250px' }}>
              <p>{ this.props.message }</p>
            </div>
          )
        }
      >
        <i className={`fa fa-info-circle ${this.props.color}`} />
      </Tooltip >
    );
  }
}
